"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Line = void 0;
var react_1 = __importDefault(require("react"));
var structure_1 = require("remota-client/component/structure");
var form_1 = require("remota-client/component/form");
var button_1 = require("remota-client/component/button");
var CONCUR_KEYS = [
    "AmountWithoutVat",
    "BuyerCostCenter",
    "CheckNumber",
    "CompanyBillToAddressCode",
    "CompanyShipToAddressCode",
    "CountryCode",
    "CurrencyCode",
    "Custom1",
    "Custom2",
    "Custom3",
    "Custom4",
    "Custom5",
    "Custom6",
    "Custom7",
    "Custom8",
    "Custom9",
    "Custom10",
    "Custom11",
    "Custom12",
    "Custom13",
    "Custom14",
    "Custom15",
    "Custom16",
    "Custom17",
    "Custom18",
    "Custom19",
    "Custom20",
    "Custom21",
    "Custom22",
    "Custom23",
    "Custom24",
    "DataSource",
    "DeliverySlipNumber",
    "Description",
    "DiscountPercentage",
    "DiscountTerms",
    "EmployeeEmailAddress",
    "EmployeeId",
    "EmployeeLoginId",
    "ExternalPolicyId",
    "InvoiceAmount",
    "InvoiceDate",
    "InvoiceNumber",
    "InvoiceReceivedDate",
    "IsEmergencyCheckRun",
    "IsInvoiceConfirmed",
    "LedgerCode",
    "LineItems.LineItem[*].AmountWithoutVat",
    "LineItems.LineItem[*].Custom1",
    "LineItems.LineItem[*].Custom2",
    "LineItems.LineItem[*].Custom3",
    "LineItems.LineItem[*].Custom4",
    "LineItems.LineItem[*].Custom5",
    "LineItems.LineItem[*].Custom6",
    "LineItems.LineItem[*].Custom7",
    "LineItems.LineItem[*].Custom8",
    "LineItems.LineItem[*].Custom9",
    "LineItems.LineItem[*].Custom10",
    "LineItems.LineItem[*].Custom11",
    "LineItems.LineItem[*].Custom12",
    "LineItems.LineItem[*].Custom13",
    "LineItems.LineItem[*].Custom14",
    "LineItems.LineItem[*].Custom15",
    "LineItems.LineItem[*].Custom16",
    "LineItems.LineItem[*].Custom17",
    "LineItems.LineItem[*].Custom18",
    "LineItems.LineItem[*].Custom19",
    "LineItems.LineItem[*].Custom20",
    "LineItems.LineItem[*].Description",
    "LineItems.LineItem[*].ExpenseTypeCode",
    "LineItems.LineItem[*].ItemCode",
    "LineItems.LineItem[*].PurchaseOrderNumber",
    "LineItems.LineItem[*].Quantity",
    "LineItems.LineItem[*].ShipFromPostalCode",
    "LineItems.LineItem[*].ShipToPostalCode",
    "LineItems.LineItem[*].SupplierPartId",
    "LineItems.LineItem[*].Tax",
    "LineItems.LineItem[*].TotalPrice",
    "LineItems.LineItem[*].UnitOfMeasure",
    "LineItems.LineItem[*].UnitPrice",
    "LineItems.LineItem[*].VatAmount",
    "LineItems.LineItem[*].VatRate",
    "Name",
    "NotesToVendor",
    "OB10BuyerId",
    "OB10TransactionId",
    "OrgUnit1",
    "OrgUnit2",
    "OrgUnit3",
    "OrgUnit4",
    "OrgUnit5",
    "OrgUnit6",
    "PaymentAdjustmentNotes",
    "PaymentAmount",
    "PaymentDueDate",
    "PaymentTermsDays",
    "ProvincialTaxId",
    "PurchaseOrderId",
    "ReceiptConfirmationType",
    "ShippingAmount",
    "TaxAmount",
    "VatAmountOne",
    "VatAmountTwo",
    "VatRateOne",
    "VatRateTwo",
    "VendorRemitAddress.Address1",
    "VendorRemitAddress.AddressCode",
    "VendorRemitAddress.Name",
    "VendorRemitAddress.PostalCode",
    "VendorRemitAddress.VendorCode",
    "VendorShipFromAddressCode",
    "VendorTaxId",
];
var Line = function (props) {
    var column = props.column, onChange = props.onChange, onDelete = props.onDelete, fields = props.fields;
    var handleSelectChange = react_1.default.useCallback(function (e) {
        var _a;
        onChange(__assign(__assign({}, column), (_a = {}, _a[e.target.name] = e.target.value, _a)));
    }, [column, onChange]);
    var handleDelete = react_1.default.useCallback(function () {
        onDelete();
    }, [onDelete]);
    return (react_1.default.createElement(structure_1.FormRowStructure, null,
        react_1.default.createElement(structure_1.FormCellStructure, { flex: "4 0" },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "Remota" },
                react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(form_1.BoxSelect, { name: "remotaKey", value: column.remotaKey, onChange: handleSelectChange },
                        react_1.default.createElement("option", { value: "" }, "\u9078\u629E\u3059\u308B"),
                        fields.map(function (field) { return (react_1.default.createElement("option", { key: field.key, value: field.key }, field.name)); }))))),
        react_1.default.createElement(structure_1.FormCellStructure, { flex: "4 0" },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "\u30B3\u30F3\u30AB\u30FC" },
                react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(form_1.BoxSelect, { name: "externalKey", value: column.externalKey, onChange: handleSelectChange },
                        react_1.default.createElement("option", { value: "" }, "\u9078\u629E\u3059\u308B"),
                        CONCUR_KEYS.map(function (key) { return (react_1.default.createElement("option", { key: key }, key)); }))))),
        react_1.default.createElement(structure_1.FormCellStructure, { flex: "2 0" },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "\u524A\u9664" },
                react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(button_1.NormalButton, { onClick: handleDelete }, "\u524A\u9664"))))));
};
exports.Line = Line;
